import React from "react";
import { Form, Formik, FormikProps } from "formik";
import { useUserProfile } from "@providers/profile";
import { Input } from "@components/primitives/input";
import { AccountFormState } from "./AccountForm.model";
import { ProfileAction } from "@providers/profile/ProfileProvider.model";
import { formatErrorMessage } from "@utils/formatErrorMessage";
import { CancelButton } from "@components/account/Account.styled";

const ChangeEmailForm = ({ state, dispatchState }: AccountFormState) => {
  const {
    profileState: { profile, authToken },
    dispatch,
    changeEmail,
  } = useUserProfile();

  const onSubmitEmail = async (values: { email: string; emailConfirm: string }) => {
    const { email, emailConfirm } = values;

    // loading set to true before making the request
    dispatchState({ ...state, loading: true });

    if (email == emailConfirm) {
      try {
        await changeEmail(email, authToken);
        // triggers a re-render of the component
        dispatchState({
          ...state,
          updated: "Email updated.",
          editing: "default",
        });
        // update reducer state profileState(profile.email) with new value
        dispatch({
          type: ProfileAction.GET_USER,
          profile: { ...profile, email },
          track: {
            eventGroup: "account",
            eventName: "updated",
          },
        });
      } catch (e) {
        dispatchState({ ...state, error: formatErrorMessage(e) });
      }
    } else {
      dispatchState({
        ...state,
        error: formatErrorMessage({ message: "Email's must match" }),
      });
    }
  };

  const onCancel = () => {
    dispatchState({ ...state, editing: "default", error: null });
  };

  return (
    <Formik
      onSubmit={(values, { setSubmitting }) => {
        onSubmitEmail(values).then(() => setSubmitting(false));
      }}
      initialValues={{ email: profile?.email || "", emailConfirm: "" }}>
      {(props: FormikProps<{ email: string; emailConfirm: string }>) => {
        const { values, errors, touched, handleChange, handleBlur, isSubmitting } = props;
        return (
          <Form className="grid-x grid-margin-x">
            <div className="cell small-12 ">
              {state.error && <p className="error">{state.error}</p>}
              <dl>
                <dt>Email Address</dt>
                <dd>{profile?.email}</dd>
              </dl>
            </div>
            <div className="cell medium-12 large-6">
              <Input
                type="email"
                name="email"
                label="Email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                error={errors.email && touched.email && errors.email}
              />
              <Input
                type="email"
                name="emailConfirm"
                label="Confirm Email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.emailConfirm}
                error={errors.email && touched.email && errors.email}
              />
            </div>
            <div>
              <input
                type="submit"
                value="Change Email"
                disabled={state.loading || isSubmitting}
                className="button inverted"
              />
              <CancelButton onClick={onCancel}>or cancel</CancelButton>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ChangeEmailForm;
